import { makeDeferred } from './fn.js';

export * as monaco from 'monaco-editor';

export const monacoInitializationDeferred = makeDeferred();
